import React, { useState } from 'react';
import { Share2, Sparkles } from 'lucide-react';
import { Achievement, Badge } from '../../types';
import ShareAchievementModal from './ShareAchievementModal';

interface ShareButtonProps {
  achievement: Achievement | Badge;
  isNew?: boolean;
}

const ShareButton: React.FC<ShareButtonProps> = ({ achievement, isNew = false }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleShare = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <button
        onClick={handleShare}
        className={`inline-flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-200 mt-2 ${
          isNew 
            ? 'bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg hover:shadow-xl transform hover:scale-105' 
            : 'bg-blue-50 text-blue-700 hover:bg-blue-100 border border-blue-200'
        }`}
      >
        {isNew && <Sparkles className="h-4 w-4" />}
        <Share2 className="h-4 w-4" />
        <span className="font-medium">
          {isNew ? 'Share New Achievement!' : 'Share'}
        </span>
      </button>
      {isModalOpen && (
        <ShareAchievementModal
          achievement={achievement}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default ShareButton;